import React from 'react'

import GeneralInputsSection from './GeneralInputsSection'
import AssumptionsSection from './AssumptionsSection'
import StakeholderDetailsSection from './StakeholderDetailsSection'

const SroiReportPayloadEditFormContent = ({ formik }) => {
  return (
    <>
      <GeneralInputsSection formik={formik} />
      <AssumptionsSection formik={formik} />
      <StakeholderDetailsSection formik={formik} />
    </>
  )
}

export default SroiReportPayloadEditFormContent
